import {priority} from '@priority-software/priority-proto-api/lib';
import {showFormClientSideMessage} from '../../Form/actions/messages';
import {texts} from '../texts';

const MAX_FILE_SIZE_MB = 0.5;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const checkHtmlSize = (htmlString: string): boolean => {
    const blob = new Blob([htmlString], {type: 'text/html'});
    const sizeInMB = blob.size / (1024 * 1024);
    return sizeInMB >= 20;
};

export function isBase64SizeGreaterThan0_5MB(base64String: string): boolean {
    const commaIndex = base64String.indexOf(',');
    const base64Data = commaIndex !== -1 ? base64String.slice(commaIndex + 1) : base64String;
    const padding = base64Data.endsWith('==') ? 2 : base64Data.endsWith('=') ? 1 : 0;
    const fileSizeInBytes = base64Data.length * 0.75 - padding;
    const size0_5MB = 0.5 * 1024 * 1024;

    return fileSizeInBytes > size0_5MB;
}

export function checkImageSize(imageBase64: string, filename?: string, fileSize?: number): boolean {
    const condition = fileSize
        ? fileSize > MAX_FILE_SIZE_BYTES
        : isBase64SizeGreaterThan0_5MB(imageBase64);

    if (condition) {
        const content = texts.check_image_size_content.replace(
            '<P1>',
            filename?.split?.('.')?.[0] || ''
        );
        showFormClientSideMessage('', priority.netitems.shared.Message.Type.Error, {
            title: texts.check_image_size_title,
            content,
            confirmButtonText: texts.check_mail_weight_btn
        });

        return true;
    }

    return false;
}
